import styled from 'styled-components'
const ModalContainer = styled.div`
    display: none;
`
const Container = styled.div`
 max-width: 767px;
 width: 100%;

`
const Heading = styled.div`
    position: relative;
    display: flex;
    align-items: flex-start;
 > h6 {
        text-align: left;
    margin: 30px 0;
    background: #ffffff;
    position: relative;
    z-index: 1;
    /* display: inline; */
    padding-right: 21px;
        }
    `
const Body = styled.div`
    text-align: left;
.recurrence {
    .app-input-text {
        max-width: 100%;
        width: 100%;
        margin:0;
    }
}
`
const RequestDate = styled.div`
    text-align: left;
    margin-top: 15px;
`
const RecurrencePattern = styled.div`
   
`
const BoxWrapper = styled.div``
const RangeofRecurrence = styled.div``
const PatternWrapper = styled.div`
    display: flex;
    @media (max-width:765px) {
        flex-direction: column;
    }
  
`
const RadioWrapper = styled.div`
    max-width: 111px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-right: 1px solid #979797;
    flex:1;
    @media (max-width:765px) {
        flex-direction: row;
        max-width: 100%;
        gap: 20px;
        border-bottom: 1px solid #979797;
        margin-bottom: 15px;
        border-right: 0;
        flex-wrap: wrap;
    }
`
const RadioData = styled.div`
    padding-left: 20px;
    flex:1;
    @media (max-width:765px) {
        padding-left: 0;
    }
`


export { Container, Heading, Body, RequestDate, RecurrencePattern, ModalContainer, BoxWrapper, RangeofRecurrence, PatternWrapper, RadioWrapper, RadioData };